import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-navigation-fill text-xl text-primary-400"></i>
              </div>
              <span className="text-lg font-semibold text-background-50">蓝色小导航</span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-400 mb-4">
              精致轻量的蓝色小导航解决方案。简洁高效、灵活定制，让页面结构更清晰，用户体验更流畅。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="/category/quick-start" className="hover:text-primary-400 transition-colors duration-200">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/quick-start" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">快速入门</Link></li>
              <li><Link to="/category/layout-design" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">布局设计</Link></li>
              <li><Link to="/category/custom-theme" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">主题定制</Link></li>
              <li><Link to="/category/responsive" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">响应式适配</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="/category/advanced" className="hover:text-primary-400 transition-colors duration-200">进阶内容</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/advanced" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">高级技巧</Link></li>
              <li><Link to="/article/performance-optimization" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">性能优化</Link></li>
              <li><Link to="/article/mega-menu-implementation" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">大型菜单实战</Link></li>
              <li><Link to="/article/accessibility-nav-design" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">无障碍设计</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="/about" className="hover:text-primary-400 transition-colors duration-200">关于我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">品牌介绍</Link></li>
              <li><a href="#contact" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">联系我们</a></li>
              <li><span className="text-sm text-foreground-400">hello@bluenav.cn</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 蓝色小导航. 采用 MIT 许可证开源.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors duration-200 text-xs whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors duration-200 text-xs whitespace-nowrap" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}